export default __webpack_public_path__ + "6bd42df288e04f2f5dfbb65cae932c8b.png";